<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter" *ngIf="tooManyStores">
              <small>{{ 'money-report.country' | transloco }}</small>
              <hx-country-select [(ngModel)]="params.countryId" [all]="false" (ngModelChange)="navigate()"></hx-country-select>
            </div>

            <div class="filter" *ngIf="tooManyStores">
              <small>{{ 'money-report.city' | transloco }}</small>
              <hx-city-select [(ngModel)]="params.cityId" [countryId]="params.countryId" [all]="false" (ngModelChange)="navigate()"></hx-city-select>
            </div>

            <div class="filter">
              <small>{{ 'money-report.shop' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeIds" [cityId]="params.cityId" [multiple]="true" (ngModelChange)="navigate()"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'money-report.data' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.date" (selectChange)="navigate()"></hx-date-range-select>
            </div>
          </div>

          <div class="table-responsive m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30">
            <table class="m-datatable__table" *ngIf="list.length && !isLoading.list">
              <thead class="m-datatable__head">
                <tr class="m-datatable__row m-datatable__row--head">
                  <th class="m-datatable__cell">
                    <span>#</span>
                  </th>

                  <th class="m-datatable__cell">
                    <span>{{ 'money-report.table.head.name' | transloco }}</span>
                  </th>

                  <th class="m-datatable__cell">
                    <span>{{ 'money-report.table.head.store' | transloco }}</span>
                  </th>

                  <th class="m-datatable__cell text-right">
                    <span>{{ 'money-report.table.head.order' | transloco }}</span>
                  </th>

                  <th class="m-datatable__cell text-right">
                    <span>{{ 'money-report.table.head.total' | transloco }}, {{ currencySymbol }}</span>
                  </th>

                  <th *ngFor="let cmn of columns" class="m-datatable__cell text-right">
                    {{'paymentType.' + cmn | transloco}}
                  </th>

                  <th class="m-datatable__cell text-right">
                    <span>{{ 'money-report.table.head.discount' | transloco }}, {{ currencySymbol }}</span>
                  </th>
                </tr>
              </thead>

              <tbody class="m-datatable__body">
                <tr *ngFor="let even = even; let i = index; let item of list" class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even }">
                  <td style="width: 40px;" class="m-datatable__cell">{{ i + 1 }}</td>

                  <td class="m-datatable__cell">
                    <a *ngIf="item.user" [title]="item.user?.fullname" [routerLink]="['full']" [queryParams]="{sale: item.user.id, dateFrom: params.date?.from, dateTo: params.date?.to, storeIds: [item.storeId] }">
                      {{ item.user?.lastname }} {{item.user?.firstname}}
                    </a>
                    <strong *ngIf="!item.user">{{ 'money-report.table.head.total' | transloco }}</strong>
                  </td>

                  <td class="m-datatable__cell text-nowrap text-right" style="min-width: 100px;">
                    {{ item.storeTitle | uiLabel }}
                  </td>

                  <td class="m-datatable__cell text-nowrap text-right" style="min-width: 100px;">
                    {{ item.count }}
                  </td>

                  <td class="m-datatable__cell text-nowrap text-right" style="min-width: 100px;">
                    {{ item.total?.toLocaleString('ru-RU') }}
                  </td>

                  <td *ngFor="let col of columns;" class="m-datatable__cell text-nowrap text-right" style="min-width: 100px;">
                    <a *ngIf="item.paymentMap.get(col)?.value && item.user" [routerLink]="['full']"
                       [queryParams]="{sale: item.user?.id, dateFrom: params.date?.from, dateTo: params.date?.to, paymentType: col, storeIds: [item.storeId] }">
                      {{ item.paymentMap.get(col)?.value }}
                    </a>
                    <a *ngIf="item.paymentMap.get(col)?.value && !item.user" [routerLink]="['full']"
                       [queryParams]="{sale: item.user?.id, dateFrom: params.date?.from, dateTo: params.date?.to, paymentType: col, storeIds: params.storeIds.join(',') }">
                      {{ item.paymentMap.get(col)?.value }}
                    </a>
                    <span *ngIf="!item.paymentMap.get(col)?.value">—</span>
                  </td>

                  <td class="m-datatable__cell text-nowrap text-right" style="min-width: 100px;">
                    <a *ngIf="item.totalDiscount" [routerLink]="['full']"
                       [queryParams]="{sale: item.user?.id, dateFrom: params.date?.from, dateTo: params.date?.to, discount: true, storeIds: params.storeIds.join(',') }">
                      {{ item.totalDiscount?.toLocaleString('ru-RU') }}
                    </a>

                    <span *ngIf="!item.totalDiscount">—</span>
                  </td>
                </tr>
              </tbody>
            </table>

            <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
